import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/webform";
import { TorontoPin } from "../../../../app-constants";

function Gettouch(props) {
  return (
    <div className="gettouch  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Connect">
              <h2>Connect Now to Discuss Your Project</h2>
            </div>
            <p>
              Connect with our experts and get valuable insights through a
              dedicated consultation session for your project idea.
            </p>
            <div className="map_loc">{TorontoPin}</div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
